import * as React from 'react';

const SvgBalance = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M36.821 4.667h-17.64c-8.82 0-11.013 2.356-11.013 11.76V42.7c0 6.207 3.407 7.677 7.537 3.243l.023-.023c1.913-2.03 4.83-1.867 6.487.35l2.356 3.15c1.89 2.497 4.947 2.497 6.837 0l2.357-3.15c1.68-2.24 4.596-2.403 6.51-.35 4.153 4.433 7.536 2.963 7.536-3.243v-26.25c.024-9.404-2.17-11.76-10.99-11.76Zm-1.82 22.75h-14c-.956 0-1.75-.794-1.75-1.75 0-.957.794-1.75 1.75-1.75h14c.957 0 1.75.793 1.75 1.75 0 .956-.793 1.75-1.75 1.75Zm2.334-9.334H18.668c-.957 0-1.75-.793-1.75-1.75 0-.956.793-1.75 1.75-1.75h18.667c.956 0 1.75.794 1.75 1.75 0 .957-.794 1.75-1.75 1.75Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgBalance;
